module.exports = __webpack_public_path__ + "img/user_hl_zx.1496c271.png";